module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container main-area"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', {
    staticClass: "centered"
  }, [_vm._v("Начальный уровень")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Программа курса")]), _vm._v(" "), _c('span', [_vm._v("Курс состоит из двух модулей")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "enroll-btn"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-md btn-block",
    attrs: {
      "to": {
        name: 'OnlineEnrollment'
      }
    }
  }, [_vm._v("Записаться")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Продолжительность курса")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("Занятия")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', [_vm._v("Стоимость")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('b-table', {
    attrs: {
      "responsive": "",
      "bordered": "",
      "striped": "",
      "fields": _vm.fields,
      "items": _vm.items
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "enroll-btn"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-md btn-block",
    attrs: {
      "to": {
        name: 'OnlineEnrollment'
      }
    }
  }, [_vm._v("Записаться")])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "course-list list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v("1. Обзорная экскурсия по городу")]), _vm._v(" "), _c('br'), _vm._v("\n            (октябрь 2022 – январь 2024)\n          ")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v("2. Трассовые экскурсии: Петергоф, Пушкин и Павловск")]), _vm._v(" "), _c('br'), _vm._v("\n            (февраль 2024 – апрель 2024)\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("с 03.10.23 по 25.04.24")]), _vm._v(" "), _c('li', [_vm._v("\n            320 ак. часов, в том числе \n            "), _c('ul', [_c('li', [_vm._v("6 учебных экскурсий (3 пешеходных, 3 автобусных)")]), _vm._v(" "), _c('li', [_vm._v("3 зачетные экскурсии")]), _vm._v(" "), _c('li', [_vm._v("самостоятельная работа с дополнительным методическим материалом")]), _vm._v(" "), _c('li', [_vm._v("работа на экскурсионном тренажере")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("вторник, четверг с 19:00 до 22:00")]), _vm._v(" "), _c('li', [_vm._v("пешеходные, учебные и зачетные экскурсии по выходным")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("за весь курс – 45 000 руб.; при единовременной оплате скидка 5% = 42 750 руб.")]), _vm._v(" "), _c('li', [_vm._v("оплата помесячно:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3417e7ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CoursesEntry.vue
// module id = 225
// module chunks = 1